import React from 'react'
import PropTypes from 'prop-types'
import { Container, Row, Col } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import Layout from '../layout'
// import { useRouter } from 'next/router'
// import Ads from '../ads'
// import useWindowSize from '@shared/hooks/windowSize'
// import { staticPages } from '@shared/constants/staticPages'
const BreadcrumbNav = dynamic(() => import('@shared/components/breadcrumbNav'))
const ATSAds = dynamic(() => import('@shared/components/atsAds'), { ssr: false })

const CMSContent = ({ data, isMobile, seoData }) => {
  // const router = useRouter()
  // const isMobileWebView = router?.query?.isMobileWebView
  // const [isPreview, setIsPreview] = useState(!!isMobileWebView)
  const cmsData = data?.getUserCMSPage
  // const [width] = useWindowSize()
  // const isStaticPage = staticPages.includes(router.asPath)

  // useEffect(() => {
  //   if (router?.query?.isMobileWebView) {
  //     setIsPreview(true)
  //   }
  // }, [router?.asPath])
  return (
    <Layout data={{ ...cmsData, oSeo: seoData }}>
      <section className="common-section pt-4">
        <ATSAds />
        <Container>
          <Row>
            <Col md={9}>
              <div className={`${styles.CMSContent}`}>
                {!isMobile && <BreadcrumbNav />}
                <h1>{cmsData?.sTitle}</h1>
                <div className={`${styles.content} mt-4`} dangerouslySetInnerHTML={{ __html: cmsData?.sContent }} />
              </div>
            </Col>
            <Col md={3}></Col>
          </Row>
        </Container>
      </section>
    </Layout>
  )
}

CMSContent.propTypes = {
  data: PropTypes.object,
  isMobile: PropTypes.bool,
  seoData: PropTypes.object
}

export default CMSContent
